export const MASTER_TYPES = [
    {name: 'Jedlo', value: 'meal'},
    {name: 'Pizza', value: 'pizza'},
    {name: 'Príloha', value: 'meal-extra'},
    {name: 'Omáčka', value: 'sauce'},
    {name: 'Nápoj', value: 'drink'},
    {name: 'Surovina na Pizzu', value: 'pizza-extra'}
]

export const RESTAURANT_PLACES = [
    {
        name: 'Bošany',
        value: 'BO',
    },
    {
        name: 'Partizánske',
        value: 'PE',
    },
]

export const ORDER_STATUS = {
    NEW: 'NEW',
    CONFIRMED: 'CONFIRMED',
    CANCELED: 'CANCELED',
    DONE: 'DONE',
    WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT'
}

export const ORDER_STATUS_PRIORITY = {
    [ORDER_STATUS.NEW]: 1,
    [ORDER_STATUS.CONFIRMED]: 2,
    [ORDER_STATUS.DONE]: 3,
    [ORDER_STATUS.CANCELED]: 4
};

export const ORDER_STATUS_OPTIONS = [
    {label: 'Všetky', value: -1},
    {label: 'Nová - čaká na prijatie', value: ORDER_STATUS.NEW},
    {label: 'Potvrdená - čaká na doručenie', value: ORDER_STATUS.CONFIRMED},
    {label: 'Zrušená', value: ORDER_STATUS.CANCELED},
    {label: 'Dokončená', value: ORDER_STATUS.DONE}
]

export const IMG_URL = 'https://agzgtvopyggthwhdvjww.supabase.co/storage/v1/object'
